export function getPercentageValue100(value: number) {
  return `${value > 100 ? "100+" : value}%`;
}
